import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/quotation-editor/components/QuotationEditorContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sidebar.tsx");
